import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getActions } from '@/infra/api/generated/actions/actions'

const { patchCustomAction, deleteCustomAction } = getActions()

const useActionLabelUpdate = () => {
  const queryClient = useQueryClient()
  const { mutateAsync: patch } = useMutation({ mutationFn: patchCustomAction })
  const { mutateAsync: remove } = useMutation({ mutationFn: deleteCustomAction })

  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ['actions'] })
    await queryClient.invalidateQueries({ queryKey: ['diagnoses', 'actions'] })
    await queryClient.invalidateQueries({ queryKey: ['diagnoses', 'history'] })
    await queryClient.invalidateQueries({ queryKey: ['priorityDiagnoses'] })
  }

  const handleActionLabelUpdate = async (actionId: string, label: string): Promise<void> => {
    await patch({ actionId, label })
    await invalidate()
  }

  const handleActionDelete = async (actionId: string): Promise<void> => {
    await remove({ actionId })
    await invalidate()
  }

  return { handleActionLabelUpdate, handleActionDelete }
}

export default useActionLabelUpdate
